module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/hairstyle_01@2x-45bd3f3f5c299ad941f9c3c987f60232.webp";